import { ProductGroup } from "api/entities/ProductGroup";
import {
  EuiButton,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiLink,
  EuiSpacer,
  EuiText,
  EuiTitle,
} from "@elastic/eui";
import { Product } from "api/entities/Product";

export interface IProductGroupCard {
  productGroup: ProductGroup;
  selectedProductId?: string;
  onProductSelected?: (product: Product) => void;
  onProductGroupClicked?: (productGroup: ProductGroup) => void;
}

export const ProductGroupCard: React.FC<IProductGroupCard> = (props) => {
  const group = props.productGroup;

  const onProductClick = (product: Product) => {
    props.onProductSelected?.(product);
  };

  const onProductGroupClick = () => {
    props.onProductGroupClicked?.(group);
  };

  return (
    <EuiCard
      id={group.id}
      title={
        <EuiTitle size={"m"}>
          {props.onProductGroupClicked ? (
            <EuiLink onClick={onProductGroupClick}>{group.name}</EuiLink>
          ) : (
            <p>{group.name}</p>
          )}
        </EuiTitle>
      }
      description={
        <>
          <EuiText>${group.setupFee} One time setup fee</EuiText>
          <EuiSpacer size={"xs"} />
          <EuiText>${group.pricePerMonth} per month</EuiText>
          <EuiSpacer size={"m"} />
          {group.clientFacingProductGroupServices.map((service) => (
            <>
              {service}
              <EuiSpacer size={"s"} />
            </>
          ))}
        </>
      }
      style={{ width: 600 }}
      footer={
        <EuiFlexGroup direction={"column"}>
          <EuiSpacer />
          <EuiFlexItem grow={false}>
            <EuiFlexGroup alignItems={"center"} justifyContent={"center"} wrap>
              {group.products.map((product) => {
                return (
                  <EuiFlexItem grow={false} key={product.id}>
                    <EuiButton
                      color={
                        props.selectedProductId === product.id
                          ? "success"
                          : "primary"
                      }
                      onClick={() => onProductClick(product)}
                    >
                      {product.name}
                      {product.setupFee
                        ? ` - $${product.setupFee} one time setup fee`
                        : ""}
                      {product.pricePerMonth
                        ? ` - $${product.pricePerMonth} per month`
                        : ""}
                    </EuiButton>
                  </EuiFlexItem>
                );
              })}
            </EuiFlexGroup>
          </EuiFlexItem>
          <EuiSpacer size="xs" />
        </EuiFlexGroup>
      }
    />
  );
};
